var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sc-dv-spin"},[_c('Spinner',{attrs:{"name":"line-scale-pulse-out","height":"32","width":"48"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }